import {
  Box,
  Chip,
  FormControl,
  FormHelperText,
  InputLabel,
  MenuItem,
  OutlinedInput,
  Select,
  useTheme,
} from '@mui/material';
import { Column, Row } from 'Components/Grid';
import { Controller } from 'react-hook-form';
import { ButtonForm } from 'Components/Form/styles';
import { useQuery } from 'react-query';
import { getSelectedContent } from 'utils/select_utils';
import { getCompanies } from 'services/company-service';
import { useTranslation } from 'react-i18next';

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

const getStyles = (name, personName, theme) => {
  return {
    fontWeight:
      personName?.indexOf(name) === -1 ? theme.typography.fontWeightRegular : theme.typography.fontWeightMedium,
  };
};

export const Managers = ({ handleBack, handleComplete, control, handleSubmit, getValues, idCompany }) => {
  const { t } = useTranslation(['company']);
  const theme = useTheme();

  const onSubmit = () => {
    handleComplete();
  };

  const { data: companies } = useQuery(['getCompanies'], async () => {
    const result = await getCompanies();
    return result?.data.length > 0
      ? idCompany
        ? result?.data.filter(company => company._id !== idCompany)
        : result?.data
      : [];
  });

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <Row justifyContent="center">
        <Column xs={12} className="d-flex">
          <Controller
            control={control}
            name="managers"
            rules={{
              validate: () => getValues('managers')?.length > 0,
              required: t('company:companies.form.managersRequired'),
            }}
            render={({ field: { onChange, value }, fieldState }) => {
              const safeValue = Array.isArray(value) ? value : [];

              const handleDelete = (selected) => {
                const newValue = safeValue.filter(v => v._id !== selected._id);
                onChange(newValue);
              };

              return (
                <FormControl fullWidth sx={{ margin: '0 auto 24px' }} error={!!fieldState.error}>
                  <InputLabel id="managers-label" shrink>
                    {t('company:companies.form.managers')}
                  </InputLabel>

                  <Select
                    labelId="managers-label"
                    id="managers"
                    multiple
                    notched
                    value={getSelectedContent(companies, safeValue)}
                    onChange={(e) => onChange(e.target.value)}
                    input={<OutlinedInput id="companies-chip" label={t('company:companies.form.managers')} />}
                    renderValue={(selected) => (
                      <Box
                        sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}
                        onMouseDown={(e) => e.stopPropagation()} // não abre menu ao interagir com chips
                      >
                        {selected?.map((selectedValue) => (
                          <Chip
                            key={`company-chip-${selectedValue._id}`}
                            label={selectedValue.name}
                            variant="outlined"
                            color="primary"
                            onMouseDown={(e) => e.stopPropagation()} // impede abrir menu ao clicar no "X"
                            onDelete={(e) => {
                              e.stopPropagation();
                              handleDelete(selectedValue); // remove apenas este
                            }}
                            sx={{ width: 'fit-content' }}
                          />
                        ))}
                      </Box>
                    )}
                    MenuProps={MenuProps}
                  >
                    {companies?.map((item) => (
                      <MenuItem
                        key={item._id}
                        value={item}
                        style={{
                          ...getStyles(item._id, safeValue.map(v => v._id), theme), // usa lista de IDs
                        }}
                      >
                        {item.name}
                      </MenuItem>
                    ))}
                  </Select>

                  <FormHelperText>
                    {fieldState.error ? fieldState.error.message : ''}
                  </FormHelperText>
                </FormControl>
              );
            }}
          />
        </Column>
      </Row>
      <Row justifyContent="end" alignItems="center">
        <Column xs={4} md={3} className="d-flex" style={{ gap: '8px', justifyContent: 'flex-end' }}>
          <ButtonForm secondary id="back" label={t('company:companies.form.back')} onClick={handleBack}></ButtonForm>
          <ButtonForm label={t('company:companies.form.save')} type="submit" />
        </Column>
      </Row>
    </form>
  );
};
